/**
 * Adapted from: Aiko
 * Source: https://github.com/tw93/aiko
 * Source commit: b7ba4c7ddff6416760f0cdf5b53d6cdd65fd1a12
 * License: MIT (README states MIT; separate LICENSE file not found in inspected source commit)
 * Modified for: Smart Shikka Core PR79 selective source adoption.
 * Safety: metadata/preview only; no runtime execution.
 */
// ---------------------------------------------------------------------------
// Deep freeze helper
// ---------------------------------------------------------------------------
function deepFreeze(value) {
    if (value === null || typeof value !== "object")
        return value;
    Object.freeze(value);
    for (const key of Object.keys(value)) {
        const child = value[key];
        if (child !== null && typeof child === "object" && !Object.isFrozen(child)) {
            deepFreeze(child);
        }
    }
    return value;
}
// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------
const SOURCE_REPO_URL = "https://github.com/tw93/aiko";
const SOURCE_COMMIT_SHA = "b7ba4c7ddff6416760f0cdf5b53d6cdd65fd1a12";
const SOURCE_LICENSE = "MIT";
const LICENSE_VERIFICATION_NOTE = "README states MIT; separate LICENSE file not found in inspected source commit. Use retained attribution and license verification note.";
const COMMON_BLOCKED_ACTIONS = deepFreeze([
    "run_source_repo_script",
    "install_source_repo_dependencies",
    "execute_icon_runtime",
    "network_call",
    "browser_automation",
    "desktop_automation",
    "read_secret",
    "db_write",
    "supabase_call",
    "provider_call",
    "copy_full_repo",
    "vendor_full_repo",
    "copy_pake_source",
    "run_pake_command",
    "auto_save",
    "auto_delete",
    "payment_trigger",
    "role_mutation",
    "secret_mutation",
]);
// ---------------------------------------------------------------------------
// Icon definitions
// ---------------------------------------------------------------------------
const AIKO_ICONS = deepFreeze([
    {
        id: "icons_svg",
        displayName: "Smart Shikka AI icon system: SVG Icon Set",
        fileName: "icons.svg",
        relativePath: "packages/core/src/aiko-icon-system/assets/icons.svg",
        sourceRepoUrl: SOURCE_REPO_URL,
        sourceCommitSha: SOURCE_COMMIT_SHA,
        sourceLicense: SOURCE_LICENSE,
        sourceLicenseVerified: false,
        licenseVerificationNote: LICENSE_VERIFICATION_NOTE,
        staticOnly: true,
        runtimeExecutionAllowed: false,
        blockedActions: COMMON_BLOCKED_ACTIONS,
        notes: [
            "Adapted from Aiko icons.svg. Static icon registry only.",
            LICENSE_VERIFICATION_NOTE,
        ],
    },
]);
// ---------------------------------------------------------------------------
// Registry
// ---------------------------------------------------------------------------
export const AIKO_ICON_REGISTRY = deepFreeze({
    version: "1.0.0",
    generatedInPr: 79,
    sourceRepoUrl: SOURCE_REPO_URL,
    sourceCommitSha: SOURCE_COMMIT_SHA,
    sourceLicense: SOURCE_LICENSE,
    sourceLicenseVerified: false,
    licenseVerificationNote: LICENSE_VERIFICATION_NOTE,
    icons: AIKO_ICONS,
});
// ---------------------------------------------------------------------------
// Lookup helpers
// ---------------------------------------------------------------------------
export function getAikoIcons() {
    return AIKO_ICON_REGISTRY.icons;
}
export function getAikoIconById(id) {
    return AIKO_ICON_REGISTRY.icons.find((i) => i.id === id);
}
//# sourceMappingURL=aikoIconRegistry.js.map